@if (appState.loading()) {
  <div class="loading-overlay">
    <div class="loading-spinner-container">
      <p-progressSpinner 
        styleClass="w-16 h-16"
        strokeWidth="4"
        animationDuration="1s"
      />
    </div>
  </div>
}
